import { environment } from '@environment';

export const slackPushApi = {
  slack_push_notification: `${environment.api.services}/api/travel-proxy-ms/notifications/slack`,
};
